import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "analytics" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_UserStats = _resolveComponent("UserStats")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tabs, {
      modelValue: _ctx.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.active) = $event)),
      class: "tabs",
      tabs: _ctx.tabs,
      bordered: "",
      "tab-position": "right"
    }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
    (_ctx.active === 'usage_reports')
      ? (_openBlock(), _createBlock($setup["UsageReports"], { key: 0 }))
      : _createCommentVNode("v-if", true),
    (_ctx.active === 'stats')
      ? (_openBlock(), _createBlock(_component_SettingsFrame, {
          key: 1,
          title: "System Stats",
          description: "These statistics cover all users in the system, across all tenants and including users without a tenant."
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UserStats, { api: $options.stats_api }, null, 8 /* PROPS */, ["api"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}